import { useState } from 'react';
import axios from 'axios';
import './SignOn.css';

const SignOn = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  // Construct API URL
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3002';

  const handleMagicLink = async () => {
    try {
      const response = await axios.post(`${apiUrl}/api/auth/login`, { email });
      setMessage(response.data.message);
      setEmail('');
    } catch (error) {
      //console.error('Error sending magic link:', error);
      setMessage('Failed to send magic link: ' + (error.response?.data?.error || 'Unknown error'));
    }
  };

  return (
    <div className="sign-on">
      <h1>Hey playa!</h1>
      <p>Sign in to MyTop25</p>
      <div className="magic-link">
        <input
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder="Enter your email"
        />
        <button onClick={handleMagicLink}>Send Magic Link</button>
        {message && <p>{message}</p>}
      </div>
    </div>
  );
};

export default SignOn;